export default function ChartsThemesContainerTemplate(data) {
    //language=HTML
    return `
        <div class="quick-icons px-md-3 py-3 chartsToolbar">
            <div class=" container-fluid">
                <div class=" border-bottom pb-2">
                    <a id="questionBtn" href="#" class=" text-secondary"><i class="fa-solid fa-arrow-right-to-bracket"></i></a>
                    <a id="refreshBtn" href="#" class=" text-secondary"><i class="fa-solid fa-arrow-rotate-right"></i></a>
                    <a id="homeBtn" href="#" class=" text-secondary"><i class="fa-solid fa-home"></i></a>
                    <div id="chartsBtnsGroup" style="padding-right: 10px; padding-left: 10px;"></div>
                </div>
            </div>
        </div>`;
}